module.exports = {
  /**
   * @description 基础url
   */
  //BASE_URL: "http://localhost:8000",
  // 部署的服务器的ip
  BASE_URL : "http://api.fgas-emissions.com",
  //BASE_URL: "http://192.168.187.133:8000",
  //BASE_URL: "http://dongtaipaifangapi.sweetysoft.com",
  // BASE_URL: "http://47.242.3.251:8000",
  BASE_URL_API: process.env.NODE_ENV === 'production' ? '/' : '/api/v1/',  // 跨域代理
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  CookieExpires: 1,
  /**
   * @description token key
   */
  TokenKey: 'TOKEN',
  /**
   * @description token key
   */
  UserKey: 'USER',
  LoginKey: 'Login',
  IsAdminKey: 'IsAdmin',
  AcitveKey: 'Active',
  /**
   * @description 请求超时时间，毫秒（默认1小时）
   */
  timeout: 1000*60*60,
  /**
   * 是否显示菜单
   */
  ShowMenu: true,
  /**
   * 是否显示面包屑
   */
  ShowBreAdcrumb: true,
  /**
   * 是否显示选项卡
   */
  ShowTabs: true,
   /**
   * 是否显示折叠按钮
   */
  ShowFold: true,
}
